import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { Button, LoaderBlock } from '@si-armes/dsfr-react';
import { connect } from 'react-redux';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import usagerClientReducer from '../../../../../../store/usagerReducer';
import {
    API_POST_VALIDER_ACQUISITION_MATERIEL,
    CONTEXT_POST_VALIDER_ACQUISITION_MATERIEL,
} from '../../../../../../constants/apiUrls.constants';
import { setLoader } from '../../../../../../store/historique/loader/historiqueLoaderReducer';

const ValiderAcquisition = ({
    postApi,
    setLoaderArme,
    armesSelectionnees,
    isLoading,
    erreur,
    data,
    ouvrirModaleValiderAcquisition,
    fermerModaleInfo,
    reinitialiseApi,
}) => {
    const validerAcquisition = () => {
        const dataFormate = armesSelectionnees.map((arme) => {
            return arme.uniquid;
        });

        postApi(
            usagerClientReducer,
            API_POST_VALIDER_ACQUISITION_MATERIEL,
            dataFormate,
            CONTEXT_POST_VALIDER_ACQUISITION_MATERIEL,
        );
    };

    const ouvrirValiderAcquisition = () => {
        ouvrirModaleValiderAcquisition(true);
        fermerModaleInfo();
    };

    useEffect(() => {
        setLoaderArme(isLoading);

        if (!isLoading && !erreur && data) {
            ouvrirValiderAcquisition();
            reinitialiseApi(CONTEXT_POST_VALIDER_ACQUISITION_MATERIEL);
        }
    }, [isLoading]);

    return (
        <LoaderBlock hideLabel label="Validation de l'acquisition" size="md" isLoading={isLoading}>
            <Button variant="primary" onClick={validerAcquisition}>
                Valider l'acquisition
            </Button>
        </LoaderBlock>
    );
};

ValiderAcquisition.propTypes = {
    postApi: PropTypes.func.isRequired,
    setLoaderArme: PropTypes.func.isRequired,
    armesSelectionnees: PropTypes.arrayOf(
        PropTypes.shape({
            uniquid: PropTypes.string.isRequired,
        }).isRequired,
    ),
    ouvrirModaleValiderAcquisition: PropTypes.func.isRequired,
    fermerModaleInfo: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    erreur: PropTypes.bool.isRequired,
    data: PropTypes.object,
    reinitialiseApi: PropTypes.func.isRequired,
};

export default connect(
    (state) => {
        const { isLoading, data, erreur } = state.materiel.validerAcquisition;
        return {
            isLoading,
            data,
            erreur,
        };
    },
    {
        postApi: postAPI,
        setLoaderArme: setLoader,
        reinitialiseApi: reinitialiseAPI,
    },
)(ValiderAcquisition);
